/** @prettier */

import ReactApexChart from 'react-apexcharts';
import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

//API import
import {getSettingUser} from '../API/API_Collection';
//type import
import {GraphDataRange, GraphTargetType, GraphUnit} from '../Type/TypeDef';

import {lineGraphBasicSetting} from './graph/setting/line/lineGraphBasicSetting';
import {specialID} from '../define';

/**
 * 折れ線グラフ
 * @param props props
 * @returns JSX.Element
 */
const PolygonalLineGraph = (props: {
  /** X軸のラベル */
  xLabel: ApexXAxis['categories'];
  /** 比較グラフのX軸のラベル */
  comparisonXLabel: ApexXAxis['categories'];
  /** Y軸のタイトル */
  yTitle: string;
  /** CSVファイルの名前（日付部分） */
  csvFileNameDate: string;
  /** CSVファイルの名前（サイトの名前 + グラフの対象の名前） */
  csvFileNameTarget: string;
  /** グラフに描画するデータ */
  graph: ApexAxisChartSeries;
  /** 比較グラフに描画するデータ */
  comparisonGraph: ApexAxisChartSeries;
  /** グラフに表示する凡例 */
  graphLegend: string[];
  /** グラフに描画する単位(°C、%等) */
  graphUnits: GraphUnit[];
  /** 比較状態判定 */
  activeComparison: boolean;
  /** グラフ描画対象 */
  graphTarget: GraphTargetType;
  /** 日付取得範囲 */
  dateRange: GraphDataRange;
}) => {
  const trans = useTranslation().t; //翻訳関数

  //prettier-ignore
  const [chartArg, setChartArg] = useState<{options: ApexCharts.ApexOptions; series: ApexAxisChartSeries | ApexNonAxisChartSeries} | null>(null); //グラフ設定
  //prettier-ignore
  const [weekComparisonChartArg, setWeekComparisonChartArg] = useState<{options: ApexCharts.ApexOptions; series: ApexAxisChartSeries | ApexNonAxisChartSeries} | null>(null); //週比較時に比較データを表示するグラフ設定

  //初回マウント時のみ実行
  useEffect(() => {
    /** グラフのCSVファイルの名前（日付） */
    let csvFileNameDate = props.csvFileNameDate;
    /** 週比較時に表示する比較側のグラフのCSVファイルの名前（日付） */
    let comparisonCsvFileNameDate = '';
    //週比較時、CSVファイルの名前（日付）を比較元と比較先で別々にする
    if (props.activeComparison && props.dateRange === 'week') {
      const csvFileNameDates = props.csvFileNameDate.split(',');
      csvFileNameDate = csvFileNameDates[0];
      comparisonCsvFileNameDate = csvFileNameDates[1];
    }
    //圧力単位を取得
    getSettingUser().then(response => {
      setChartArg(
        lineGraphBasicSetting({
          xLabel: props.xLabel,
          yTitle: props.yTitle,
          csvFileNameDate: csvFileNameDate,
          csvFileNameTarget: props.csvFileNameTarget,
          graphData: props.graph,
          graphLegend: props.graphLegend,
          graphUnits: props.graphUnits,
          pressureUnit: response['unit'].pressure,
          graphTarget: props.graphTarget,
          dateRange: props.dateRange,
          comparisonGraph:
            props.dateRange === 'day' ? props.activeComparison : false,
          weekComparisonGraph: false,

          trans: trans,
        })
      );
      //週比較時に比較データを表示するグラフに送るデータ
      setWeekComparisonChartArg(
        lineGraphBasicSetting({
          xLabel: props.comparisonXLabel,
          yTitle: props.yTitle,
          csvFileNameDate: comparisonCsvFileNameDate,
          csvFileNameTarget: props.csvFileNameTarget,
          graphData: props.comparisonGraph,
          graphLegend: props.graphLegend,
          graphUnits: props.graphUnits,
          pressureUnit: response['unit'].pressure,
          graphTarget: props.graphTarget,
          dateRange: props.dateRange,
          comparisonGraph: false,
          weekComparisonGraph: true,
          trans: trans,
        })
      );
    });
  }, []);

  if (chartArg === null) return <></>;
  if (weekComparisonChartArg === null) return <></>;

  //週比較状態でない場合
  if (
    props.dateRange === 'day' ||
    (props.dateRange === 'week' && props.activeComparison === false)
  ) {
    return (
      // グラフ表示設定
      <ReactApexChart
        id={specialID.IGNORE_INTERACTJS_ID}
        options={chartArg.options}
        series={chartArg.series}
        type="area"
        height="85%"
      />
    );
  }
  //週比較状態の場合
  return (
    <>
      {/* 通常日のデータを表示するグラフ設定 */}
      <ReactApexChart
        id={specialID.IGNORE_INTERACTJS_ID}
        options={chartArg.options}
        series={chartArg.series}
        type="area"
        height="60%"
      />
      {/* 比較日のデータを表示するグラフ設定 */}
      <ReactApexChart
        id={specialID.IGNORE_INTERACTJS_ID}
        options={weekComparisonChartArg.options}
        series={weekComparisonChartArg.series}
        type="area"
        height="60%"
      />
    </>
  );
};
export default PolygonalLineGraph;
